import type { TweetListResponsePageAllOfThreeContentItemMediaLinksItem } from './tweetListResponsePageAllOfThreeContentItemMediaLinksItem';

/**
 * 미디어 정보
 */
export type TweetListResponsePageAllOfThreeContentItemMedia = {
  /** 링크 프리뷰 정보 목록 */
  links?: TweetListResponsePageAllOfThreeContentItemMediaLinksItem[];
  /** 미디어 ID 목록 */
  mediaIds?: number[];
  /** 미디어 URL 목록 (이미지, 비디오, 오디오 등) */
  mediaUrls?: string[];
};
